"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[1806],{

/***/ 29196:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $W: () => (/* binding */ primitivesDark),
/* harmony export */   $z: () => (/* binding */ EditLightProductionTheme),
/* harmony export */   CG: () => (/* binding */ EditLightTheme),
/* harmony export */   DE: () => (/* binding */ monoFontFamily),
/* harmony export */   _8: () => (/* binding */ proseFamily),
/* harmony export */   bw: () => (/* binding */ EditDarkProductionTheme),
/* harmony export */   e5: () => (/* binding */ EditDarkTheme),
/* harmony export */   i$: () => (/* binding */ editOverrides),
/* harmony export */   rx: () => (/* binding */ primitivesLight),
/* harmony export */   uT: () => (/* binding */ defaultSemanticOverrides),
/* harmony export */   xF: () => (/* binding */ EditLayout)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78739);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25450);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12495);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95891);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72919);
/* eslint-disable @typescript-eslint/no-empty-object-type */ 



const monoFontFamily = `Inconsolata, Monaco, monospace`;
const proseFamily = `Inter, -apple-system, BlinkMacSystemFont, sans-serif`;
const editOverrides = {
    name: "edit",
    borders: {
        radius200: "4px",
        radius300: "8px",
        radius400: "10px",
        radius500: "12px",
        checkboxBorderRadius: "4px"
    },
    grid: {
        columns: [
            4,
            8,
            12
        ],
        gutters: [
            16,
            16,
            16
        ],
        margins: [
            0,
            12,
            24
        ]
    },
    lighting: {
        ..._primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetShadows */ .Kj,
        shadow400: "0px 1px 0px rgba(0, 0, 0, 0.07);",
        shadow700: "-2px 2px 0px rgba(0, 0, 0, 0.07);"
    },
    typography: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateTypography */ .pN)({
        primaryFamily: monoFontFamily,
        monoFamily: monoFontFamily
    }, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .productTypography */ .VY)
};
var SemanticType = /*#__PURE__*/ function(SemanticType) {
    SemanticType[SemanticType["Development"] = 0] = "Development";
    SemanticType[SemanticType["Production"] = 1] = "Production";
    return SemanticType;
}(SemanticType || {});
const getSemanticOverrides = (type, colors)=>{
    const developmentOverrides = {
        colors: {
            ...colors,
            themedAlpha50: colors.alpha50,
            themedAlpha100: colors.alpha100,
            themedAlpha200: colors.alpha200,
            themedAlpha300: colors.alpha300,
            themedAlpha400: colors.alpha400,
            themedAlpha500: colors.alpha500,
            themedAlpha600: colors.alpha600,
            themedAlpha700: colors.alpha700,
            themedPrimary50: colors.primary50,
            themedPrimary100: colors.primary100,
            themedPrimary200: colors.primary200,
            themedPrimary300: colors.primary300,
            themedPrimary400: colors.primary400,
            themedPrimary500: colors.primary500,
            themedPrimary600: colors.primary600,
            themedPrimary700: colors.primary700,
            accent100: colors.electricBlue100,
            accent200: colors.electricBlue200,
            accent300: colors.electricBlue300,
            accent400: colors.electricBlue400,
            accent500: colors.electricBlue500,
            accent600: colors.electricBlue600,
            accent700: colors.electricBlue700,
            contentOnColor: colors.neutralMax,
            contentSecondary: colors.primary500,
            contentSecondaryOriginal: colors.primary600,
            contentAccent: colors.electricBlue500,
            contentInfo: colors.cyan700,
            contentNegative: colors.red500,
            contentWarning: colors.yellow700,
            contentPositive: colors.green700,
            contentDevelopment: colors.development,
            contentProduction: colors.purple500,
            contentDisabledDevelopment: colors.disabledDevelopment,
            backgroundTertiary: colors.primary50,
            backgroundQuaternary: colors.primary200,
            backgroundQuinary: colors.primary300,
            backgroundInverseTertiary: colors.primary700,
            backgroundInfo: colors.cyan50,
            backgroundNegative: colors.red50,
            backgroundWarning: colors.yellow50,
            backgroundPositive: colors.green50,
            backgroundSubtleBlue: colors.electricBlue50,
            backgroundProduction: "#C5ADFA36",
            border: colors.alpha300,
            borderFocus: colors.electricBlue500,
            borderSelected: colors.electricBlue400,
            borderOpaque: colors.alpha300,
            borderAlt: colors.primary200,
            borderInfo: colors.cyan500,
            borderNegative: colors.red500,
            borderError: colors.red500,
            borderWarning: colors.yellow600,
            borderPositive: colors.green200,
            buttonPrimaryFill: colors.primary700,
            buttonPrimaryHover: colors.primary600,
            buttonSecondaryFill: colors.neutralMin,
            buttonSecondaryHover: colors.primary50,
            buttonTertiaryHover: colors.alpha0,
            inputFill: "rgba(0, 0, 0, 0.01)",
            inputFillActive: colors.neutralMin,
            inputBorder: colors.primary300,
            inputBorderError: colors.red500,
            linkText: colors.primary700,
            linkVisited: colors.primary700,
            linkHover: colors.primary600,
            contentLinkText: colors.blue500,
            contentLinkTextSecondary: colors.yellow300,
            contentLinkHover: colors.blue600,
            contentLinkActive: colors.blue700,
            menuFontDefault: colors.neutralMax,
            tickBorderError: colors.red500,
            tickFillErrorSelected: colors.red500,
            tickFillErrorSelectedHover: colors.red600,
            tickFillErrorSelectedHoverActive: colors.red700,
            backgroundEnvironmentSettingsCallout: colors.backgroundEnvironmentSettingsCalloutDevelopment,
            contentEnvironmentSettingsCallout: colors.contentEnvironmentSettingsCalloutDevelopment
        },
        borders: {
            buttonBorderRadius: "6px",
            inputBorderRadius: "6px",
            popoverBorderRadius: "6px",
            surfaceBorderRadius: "8px",
            tableBorderRadius: "8px"
        }
    };
    if (type == 1) {
        const productionOverrides = {
            colors: {
                themedAlpha50: colors.purpleAlpha50,
                themedAlpha100: colors.purpleAlpha100,
                themedAlpha200: colors.purpleAlpha200,
                themedAlpha300: colors.purpleAlpha300,
                themedAlpha400: colors.purpleAlpha400,
                themedAlpha500: colors.purpleAlpha500,
                themedAlpha600: colors.purpleAlpha600,
                themedAlpha700: colors.purpleAlpha700,
                themedPrimary50: colors.purple50,
                themedPrimary100: colors.purple100,
                themedPrimary200: colors.purple200,
                themedPrimary300: colors.purple300,
                themedPrimary400: colors.purple400,
                themedPrimary500: colors.purple500,
                themedPrimary600: colors.purple600,
                themedPrimary700: colors.purple700,
                contentSecondaryOriginal: colors.purple600,
                contentInfo: colors.purple600,
                backgroundTertiary: colors.purple50,
                backgroundQuaternary: colors.purple100,
                backgroundQuinary: colors.purple300,
                backgroundInverseTertiary: colors.purple700,
                backgroundInfo: colors.purple50,
                borderFocus: colors.purple500,
                borderSelected: colors.purple400,
                borderOpaque: colors.purple200,
                borderAlt: colors.purple200,
                borderInfo: colors.purple200,
                contentLinkTextSecondary: colors.electricBlue500,
                tableStripedBackground: colors.purple50,
                backgroundEnvironmentSettingsCallout: colors.backgroundEnvironmentSettingsCalloutProduction,
                contentEnvironmentSettingsCallout: colors.contentEnvironmentSettingsCalloutProduction
            },
            borders: {
                // NOTE: These colours are opaque, while the default border colours are transparent
                border100: {
                    borderColor: colors.purple50
                },
                border200: {
                    borderColor: colors.purple100
                },
                border300: {
                    borderColor: colors.purple200
                },
                border400: {
                    borderColor: colors.purple300
                },
                border500: {
                    borderColor: colors.purple400
                },
                border600: {
                    borderColor: colors.purple500
                }
            }
        };
        return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, developmentOverrides, productionOverrides);
    } else {
        return developmentOverrides;
    }
};
// PRIMITIVE OVERRIDES ////////////////////////////////////////////////////////
const primitivesLight = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .gh)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .dj)
};
const primitivesDark = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .gh)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .pM)
};
// COLOR PALETTE OVERRIDES ////////////////////////////////////////////////////
const defaultSemanticOverrides = getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .dj);
const EditLightTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, defaultSemanticOverrides, editOverrides));
const EditLightProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .dj), editOverrides));
const EditDarkTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .pM), editOverrides));
const EditDarkProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .pM), editOverrides));
// for debugging, its nice to be able to just see the theme values easily
if (false) {}
const EditLayout = {
    smallSubNavigationWidth: "368px",
    mediumSubNavigationWidth: "392px",
    minimumEditPaneWidth: "432px",
    maximumEditPaneWidth: "816px",
    connectionsIndexWidth: "1048px",
    connectionsModalWidth: "900px",
    appSettingIndexWidth: "1150px",
    resizablePaneStartWidth: 526
};


/***/ }),

/***/ 15530:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const Column = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("div", (props)=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: props.$align,
        gap: props.$gap
    }));


/***/ }),

/***/ 79638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ Row),
/* harmony export */   h: () => (/* binding */ Spacer)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const Row = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("div", (props)=>({
        display: "flex",
        flexDirection: "row",
        justifyContent: props.$align,
        alignItems: "center",
        gap: props.$gap
    }));
const Spacer = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("div", {
    flexGrow: 1
});


/***/ }),

/***/ 36129:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $n: () => (/* binding */ Button),
/* harmony export */   E3: () => (/* binding */ ButtonHoverSelector),
/* harmony export */   QA: () => (/* binding */ ButtonActiveSelector),
/* harmony export */   ZN: () => (/* binding */ ButtonKind)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89944);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78803);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72919);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83712);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65171);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12495);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64234);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81724);
/* harmony import */ var _utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45439);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59356);


// eslint-disable-next-line no-restricted-imports






// eslint-disable-next-line no-restricted-imports

const ButtonHoverSelector = ":hover:not(:disabled):not(:active)";
const ButtonActiveSelector = ":active:not(:disabled)";
/**
 * BaseUI reexport for minimal buttons because we need to pass overrides to style the text right. Wherever you want to use a <Button />, you should use this instead.
 * See https://github.com/uber/baseweb/issues/106 for more information
 */ const ButtonKind = {
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
    minimal: "minimal",
    danger: "danger",
    delete: "delete",
    tertiaryDestructive: "tertiaryDestructive",
    ai: "ai"
};
const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .c6)();
    const rawProps = {};
    const { disableButtons } = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* .useWidgets */ .X)();
    const disabled = props.disabled ?? disableButtons?.(props);
    const kind = props.kind ?? "primary";
    const rawSize = props.size == "tight" ? baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact : props.size == "square" ? baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.default : props.size;
    let overrides = {
        BaseButton: {
            style: {
                cursor: disabled ? "not-allowed !important" : "pointer",
                transitionProperty: "background, background-color",
                transitionDuration: "0s",
                ":focus-visible": {
                    outline: `2px solid ${$theme.colors.borderFocus}`,
                    outlineOffset: "1px"
                },
                userSelect: "none"
            }
        },
        StartEnhancer: {
            style: {
                marginRight: $theme.sizing.scale300
            }
        },
        EndEnhancer: {
            style: {
                marginLeft: $theme.sizing.scale300
            }
        }
    };
    switch(props.size){
        case "tight":
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .Kl)($theme.sizing.scale0)
                    }
                });
                break;
            }
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.large:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: {
                            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingVertical */ .kx)($theme.sizing.scale300),
                            ...$theme.typography.body
                        }
                    }
                });
                break;
            }
        case undefined:
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact:
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.default:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .Kl)($theme.sizing.scale200, $theme.sizing.scale500)
                    },
                    StartEnhancer: {
                        style: {
                            marginRight: kind == "minimal" || kind == "tertiary" ? $theme.sizing.scale200 : $theme.sizing.scale400
                        }
                    }
                });
            }
    }
    const activeStyle = {
        backgroundColor: "transparent",
        boxShadow: "none",
        textDecoration: "underline"
    };
    const style = {
        ai: {
            color: $theme.colors.white,
            position: "relative",
            border: "none",
            borderRadius: "6px",
            background: "radial-gradient(328.56% 59.57% at 47.73% 203.91%, rgba(255, 90, 227, 0.23) 0%, rgba(62, 12, 43, 0.61) 100%), #000;",
            boxShadow: "0px -4px 6px 1px rgba(92, 8, 96, 0.36) inset, 0px 4px 6px 2px rgba(203, 77, 200, 0.21) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16), 0px -2px 0px 0px rgba(0, 0, 0, 0.24) inset;",
            [ButtonHoverSelector]: {
                background: "radial-gradient(328.56% 59.57% at 47.73% 203.91%, rgba(255, 90, 227, 0.49) 0%, rgba(106, 29, 76, 0.61) 100%), #000"
            },
            [ButtonActiveSelector]: {
                background: "radial-gradient(328.56% 59.57% at 47.73% 203.91%, rgba(199, 56, 175, 0.61) 0%, rgba(62, 12, 43, 0.61) 100%), #000;"
            },
            [ButtonActiveSelector + " > *"]: {
                transform: "translateY(1px)"
            },
            ":disabled": {
                backgroundColor: $theme.colors.alpha300,
                color: $theme.colors.primary50,
                boxShadow: "none"
            }
        },
        primary: {
            backgroundColor: $theme.colors.primary700,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.neutralMax, 1, $theme.lighting.shadowButtonPrimary),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .rH)(0),
            [ButtonActiveSelector]: {
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.neutralMax, 0, $theme.lighting.shadowButtonPrimaryInset)
            },
            [ButtonActiveSelector + " > *"]: {
                transform: "translateY(1px)"
            },
            ":disabled": {
                backgroundColor: $theme.colors.alpha300,
                color: $theme.colors.primary50,
                boxShadow: "none"
            }
        },
        secondary: {
            color: $theme.colors.contentOnColor,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.primary300, 1, $theme.lighting.shadowButton),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .rH)(0),
            backgroundColor: $theme.colors.neutralMin,
            [ButtonActiveSelector]: {
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.primary300, 1, $theme.lighting.shadowButtonInset),
                backgroundColor: $theme.colors.primary50
            },
            [ButtonActiveSelector + " > *"]: {
                transform: "translateY(1px)"
            },
            ":disabled": {
                backgroundColor: $theme.colors.alpha50,
                boxShadow: "none"
            }
        },
        tertiary: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .Kl)("0px"),
            color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact ? $theme.colors.linkText : $theme.colors.contentLinkText,
            textDecoration: $theme.typography.contentLink?.textDecoration ?? "none",
            backgroundColor: "transparent",
            textUnderlineOffset: "3px",
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .rH)(0),
            ":hover:not(:disabled)": {
                ...activeStyle
            },
            [ButtonHoverSelector]: {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover
            },
            ":focus-visible": {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover,
                outlineOffset: "3px"
            },
            ":disabled": {
                color: $theme.colors.alpha400,
                backgroundColor: "transparent"
            },
            [ButtonActiveSelector]: {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact ? $theme.colors.linkActive : $theme.colors.contentLinkActive,
                transform: "perspective(500px) translate3d(0, 0, -20px)"
            }
        },
        danger: {
            backgroundColor: $theme.colors.red500,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.red600, 1, $theme.lighting.shadowButtonPrimary),
            [ButtonHoverSelector]: {
                backgroundColor: $theme.colors.red400,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.red500, 1, $theme.lighting.shadowButtonPrimary)
            },
            [ButtonActiveSelector]: {
                backgroundColor: $theme.colors.red400,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.red400, 1, $theme.lighting.shadowButtonPrimaryInset)
            },
            [ButtonActiveSelector + " > *"]: {
                transform: "translateY(1px)"
            },
            ":disabled": {
                boxShadow: "none",
                border: `1px solid ${$theme.colors.primary100}`
            }
        },
        delete: {
            color: $theme.colors.red500,
            backgroundColor: $theme.colors.neutralMin,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.red200, 1, $theme.lighting.shadowButton),
            [ButtonHoverSelector]: {
                backgroundColor: $theme.colors.red50,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.red300, 1, $theme.lighting.shadowButton)
            },
            [ButtonActiveSelector]: {
                backgroundColor: $theme.colors.red50,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .NH)($theme.colors.red400, 1, $theme.lighting.shadowButtonInset)
            },
            [ButtonActiveSelector + " > *"]: {
                transform: "translateY(1px)"
            },
            ":disabled": {
                boxShadow: "none",
                color: $theme.colors.primary50,
                backgroundColor: $theme.colors.primary300,
                border: `1px solid ${$theme.colors.primary300}`
            }
        },
        tertiaryDestructive: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .Kl)("0px"),
            color: $theme.colors.red500,
            backgroundColor: "transparent",
            ":hover:not(:disabled)": {
                backgroundColor: "transparent",
                boxShadow: "none"
            },
            [ButtonHoverSelector]: {
                backgroundColor: "transparent",
                boxShadow: "none",
                color: $theme.colors.red600
            },
            ":focus-visible": {
                backgroundColor: "transparent",
                boxShadow: "none",
                color: $theme.colors.red600,
                outlineOffset: "3px"
            },
            [ButtonActiveSelector]: {
                backgroundColor: "transparent",
                color: $theme.colors.red700,
                transform: "perspective(500px) translate3d(0, 0, -20px)"
            }
        }
    };
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
        BaseButton: {
            style: style[kind]
        }
    });
    overrides = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .mergeOverrides */ .Qp)(overrides, props.overrides);
    if (props.$style) {
        lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides.BaseButton.style, props.$style);
    }
    if (props.$pressed || props.isSelected) {
        const style = overrides.BaseButton?.style;
        if (style?.[":active:not(:disabled)"]) {
            lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides.BaseButton.style, style[":active:not(:disabled)"]);
        }
    }
    // normalizeKeys is not a valid prop for Button
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(rawProps, lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
        "children",
        "normalizeKeys"
    ]));
    // wrap any child that is a raw string in a wrapper span, so that the CSS selectors which translate the children on active can target them. children that are already an element and not a string aren't wrapped to keep things as unchanged as possible
    // eslint-disable-next-line react/jsx-key
    const children = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(props.children, (child)=>{
        return typeof child === "string" ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
            style: {
                whiteSpace: overrides.BaseButton?.style?.whiteSpace ?? "pre-wrap"
            }
        }, child) : child;
    });
    const basewebKind = kind == "delete" ? "secondary" : kind == "danger" ? "primary" : kind == "tertiaryDestructive" ? "tertiary" : kind;
    const button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(baseui_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A, {
        ref: ref,
        ...rawProps,
        disabled: disabled,
        overrides: overrides,
        kind: basewebKind,
        size: rawSize,
        draggable: props.draggable ? true : false
    }, children);
    return props.normalizeKeys ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_9__/* .KeyNormalizedControl */ .g, {
        mode: "simple",
        ignoreKeyProps: {
            style: {
                lineHeight: "0"
            }
        }
    }, button) : button;
});


/***/ }),

/***/ 93189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ PlainButton)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12495);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72919);



/**
 * A plain button component that doesn't apply any styling to the contents
 *
 * Useful for making clickable elements inside other things. Try to use this instead of a `div` or `Row` with an `onClick` :)
 */ const PlainButton = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .I4)("button", ({ $theme, $row, $selected, $style })=>{
    return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        fontFamily: "inherit",
        lineHeight: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        textDecoration: "underline",
        display: $row ? "flex" : "initial",
        alignItems: "center",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandPadding */ .ij)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandMargin */ .RJ)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandBorderWidth */ .rH)("0px"),
        backgroundColor: $selected ? $theme.colors.primary200 : "unset",
        width: "min-content",
        whiteSpace: "nowrap",
        textUnderlinePosition: "under",
        color: "unset",
        ":hover": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset",
            color: $theme.colors.contentTertiary,
            cursor: "pointer"
        },
        ":active": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset"
        },
        ":focus-visible": {
            outline: `auto 1px ${$theme.colors.borderFocus}`
        }
    }, $style);
});


/***/ }),

/***/ 59356:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ useWidgets),
/* harmony export */   Z: () => (/* binding */ WidgetsContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);

const WidgetsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const useWidgets = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(WidgetsContext);
    return context ?? {};
};


/***/ }),

/***/ 30211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);


const CloseIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .B, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z",
        fill: props.color ?? "currentColor"
    }));


/***/ }),

/***/ 71919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ WarningIcon),
/* harmony export */   s: () => (/* binding */ WarningOutlineIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



const WarningIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .B, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        x: "7",
        y: "5",
        width: "2",
        height: "8",
        fill: "transparent"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M7.99998 1.59998C7.55648 1.59998 7.17655 1.87023 7.01561 2.25518L1.22707 12.2385V12.2396C1.1226 12.4078 1.06705 12.6019 1.06665 12.8C1.06665 13.0829 1.17903 13.3542 1.37907 13.5542C1.57911 13.7543 1.85042 13.8666 2.13332 13.8666C2.15835 13.8665 2.18336 13.8654 2.20832 13.8635L2.2104 13.8666H7.99998H13.7896L13.7917 13.8625C13.8166 13.8647 13.8416 13.8661 13.8667 13.8666C14.1495 13.8666 14.4209 13.7543 14.6209 13.5542C14.8209 13.3542 14.9333 13.0829 14.9333 12.8C14.9331 12.6015 14.8776 12.4071 14.7729 12.2385L14.7646 12.2239C14.7642 12.2236 14.7639 12.2232 14.7635 12.2229L8.98436 2.25518C8.82342 1.87023 8.44349 1.59998 7.99998 1.59998ZM7.35311 6.05831H8.64686L8.53957 9.51039H7.4604L7.35311 6.05831ZM8.00207 10.5656C8.44047 10.5656 8.70311 10.8015 8.70311 11.2041C8.70311 11.5993 8.44047 11.8343 8.00207 11.8343C7.56047 11.8343 7.29582 11.5993 7.29582 11.2041C7.29582 10.8015 7.55993 10.5656 8.00207 10.5656Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.yellow500)
    }));
};
const WarningOutlineIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .B, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6.99907 1.47461C6.54569 1.47461 6.0923 1.69569 5.84721 2.13827L1.33208 10.2952C0.855896 11.1556 1.50059 12.2509 2.48393 12.2509H11.5148C12.4981 12.2509 13.1428 11.1556 12.6666 10.2952L8.15092 2.13827C7.90584 1.69569 7.45245 1.47461 6.99907 1.47461ZM6.99907 2.31942C7.14739 2.31942 7.29556 2.40004 7.3853 2.56209L11.901 10.7191C12.0741 11.0318 11.8714 11.3759 11.5148 11.3759H2.48393C2.12735 11.3759 1.92463 11.0318 2.0977 10.7191L6.61284 2.56209C6.70258 2.40004 6.85074 2.31942 6.99907 2.31942ZM6.99223 4.6613C6.8763 4.66311 6.76583 4.71086 6.68508 4.79407C6.60433 4.87727 6.55991 4.98913 6.56157 5.10506V8.02173C6.56075 8.0797 6.57146 8.13726 6.59308 8.19106C6.6147 8.24486 6.64679 8.29382 6.6875 8.33511C6.72821 8.3764 6.77671 8.40918 6.8302 8.43156C6.88369 8.45394 6.94109 8.46546 6.99907 8.46546C7.05705 8.46546 7.11445 8.45394 7.16794 8.43156C7.22143 8.40918 7.26993 8.3764 7.31064 8.33511C7.35135 8.29382 7.38344 8.24486 7.40506 8.19106C7.42668 8.13726 7.43739 8.0797 7.43657 8.02173V5.10506C7.43741 5.04651 7.42649 4.98838 7.40445 4.93412C7.38241 4.87986 7.3497 4.83058 7.30826 4.7892C7.26683 4.74781 7.2175 4.71517 7.16322 4.6932C7.10893 4.67123 7.05079 4.66038 6.99223 4.6613ZM6.99907 9.33423C6.84436 9.33423 6.69599 9.39569 6.58659 9.50508C6.47719 9.61448 6.41574 9.76285 6.41574 9.91756C6.41574 10.0723 6.47719 10.2206 6.58659 10.33C6.69599 10.4394 6.84436 10.5009 6.99907 10.5009C7.15378 10.5009 7.30215 10.4394 7.41155 10.33C7.52094 10.2206 7.5824 10.0723 7.5824 9.91756C7.5824 9.76285 7.52094 9.61448 7.41155 9.50508C7.30215 9.39569 7.15378 9.33423 6.99907 9.33423Z",
        fill: "currentColor"
    }));
};


/***/ }),

/***/ 95891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Kj: () => (/* binding */ gadgetShadows),
/* harmony export */   O7: () => (/* binding */ radii),
/* harmony export */   VY: () => (/* binding */ productTypography),
/* harmony export */   dj: () => (/* binding */ gadgetColorsLight),
/* harmony export */   gh: () => (/* binding */ getPrimitiveColors),
/* harmony export */   pM: () => (/* binding */ gadgetColorsDark),
/* harmony export */   xe: () => (/* binding */ space)
/* harmony export */ });
const gadgetColorsLight = {
    neutralMin: "#FFF",
    neutralMax: "#000",
    primary50: "#F6F6F6",
    primary100: "#EEEEEE",
    primary200: "#E2E2E2",
    primary300: "#CBCBCB",
    primary400: "#AFAFAF",
    primary500: "#757575",
    primary600: "#545454",
    primary700: "#333333",
    alpha0: "rgba(0, 0, 0, 0)",
    alpha50: "rgba(0, 0, 0, 0.03)",
    alpha100: "rgba(0, 0, 0, 0.07)",
    alpha200: "rgba(0, 0, 0, 0.11)",
    alpha300: "rgba(0, 0, 0, 0.2)",
    alpha400: "rgba(0, 0, 0, 0.31)",
    alpha500: "rgba(0, 0, 0, 0.54)",
    alpha600: "rgba(0, 0, 0, 0.67)",
    alpha700: "rgba(0, 0, 0, 0.8)",
    alpha800: "rgba(0, 0, 0, 0.9)",
    alpha900: "rgba(0, 0, 0, 0.95)",
    electricBlue50: "#ECECFF",
    electricBlue100: "#D9D9FE",
    electricBlue200: "#B3B3FE",
    electricBlue300: "#8E8EFD",
    electricBlue400: "#6868FD",
    electricBlue500: "#4242FC",
    electricBlue600: "#3535CE",
    electricBlue700: "#2828A0",
    yellow50: "#FFF8EC",
    yellow100: "#FDEDD6",
    yellow200: "#FBE6BC",
    yellow300: "#FACF8F",
    yellow400: "#FCBC63",
    yellow500: "#DC892A",
    yellow600: "#A66822",
    yellow700: "#6F4616",
    red50: "#FFEDEB",
    red100: "#FFDBD7",
    red200: "#F7AEA6",
    red300: "#F27769",
    red400: "#DB3927",
    red500: "#B13325",
    red600: "#8C2B20",
    red700: "#6D1F17",
    green50: "#F0F9F4",
    green100: "#DAF0E3",
    green200: "#AEDDC2",
    green300: "#73C496",
    green400: "#3AA76D",
    green500: "#368759",
    green600: "#2B6B46",
    green700: "#1C472F",
    blue50: "#F0F3FD",
    blue100: "#D7E2FA",
    blue200: "#A6BEF3",
    blue300: "#6790EE",
    blue350: "#007BFF",
    blue400: "#3B6CE9",
    blue500: "#2D53B1",
    blue600: "#23418C",
    blue700: "#172B5D",
    cyan50: "#EFF8FF",
    cyan100: "#D2EFFF",
    cyan200: "#B6E5FF",
    cyan300: "#92D7FE",
    cyan400: "#63C7FF",
    cyan500: "#3A9BD1",
    cyan600: "#3383AF",
    cyan700: "#1B5B80",
    purple50: "#F7F5FD",
    purple100: "#F1EBFF",
    purple200: "#DBCBFF",
    purple300: "#BEA1FF",
    purple400: "#9E72FE",
    purple500: "#6F4BCD",
    purple600: "#5B38B6",
    purple700: "#3B227A",
    purpleAlpha50: "rgba(62, 14, 169, 0.04)",
    purpleAlpha100: "#4F00FF14",
    purpleAlpha200: "#5407FE36",
    purpleAlpha300: "#5407FE61",
    purpleAlpha400: "#5407FE91",
    purpleAlpha500: "#4208C2BF",
    purpleAlpha600: "#3500ABCC",
    purpleAlpha700: "#210066DE",
    gellyPurple: "#9B50D7",
    development: "#404B5A",
    disabledDevelopment: "#404B5AB2",
    backgroundDevelopment: "rgba(162, 185, 215, 0.21)",
    inputAlpha: "rgba(0, 0, 0, 0.01)",
    splashIllustrationBackground: "#F8F8FE",
    backgroundEnvironmentSettingsCalloutDevelopment: "#EBF0F6",
    contentEnvironmentSettingsCalloutDevelopment: "rgba(64, 75, 90, 0.60)",
    backgroundEnvironmentSettingsCalloutProduction: "#F2EDFD",
    backgroundProduction: "#C5ADFA36",
    contentEnvironmentSettingsCalloutProduction: "#5634AE99"
};
const gadgetColorsDark = {
    neutralMin: "#000",
    neutralMax: "#FFF",
    primary50: "#333333",
    primary100: "#545454",
    primary200: "#757575",
    primary300: "#AFAFAF",
    primary400: "#CBCBCB",
    primary500: "#E2E2E2",
    primary600: "#EEEEEE",
    primary700: "#F6F6F6",
    alpha0: "rgba(255, 255, 255, 0)",
    alpha50: "rgba(255, 255, 255, 0.03)",
    alpha100: "rgba(255, 255, 255, 0.07)",
    alpha200: "rgba(255, 255, 255, 0.11)",
    alpha300: "rgba(255, 255, 255, 0.2)",
    alpha400: "rgba(255, 255, 255, 0.31)",
    alpha500: "rgba(255, 255, 255, 0.54)",
    alpha600: "rgba(255, 255, 255, 0.67)",
    alpha700: "rgba(255, 255, 255, 0.8)",
    alpha800: "rgba(255, 255, 255, 0.9)",
    alpha900: "rgba(255, 255, 255, 0.95)",
    electricBlue50: "#2828A0",
    electricBlue100: "#3535CE",
    electricBlue200: "#4242FC",
    electricBlue300: "#6868FD",
    electricBlue400: "#8E8EFD",
    electricBlue500: "#B3B3FE",
    electricBlue600: "#D9D9FE",
    electricBlue700: "#ECECFF",
    yellow50: "#6F4616",
    yellow100: "#A66822",
    yellow200: "#DC892A",
    yellow300: "#FCBC63",
    yellow400: "#FACF8F",
    yellow500: "#FBE6BC",
    yellow600: "#FDEDD6",
    yellow700: "#FFF8EC",
    red50: "#6D1F17",
    red100: "#8C2B20",
    red200: "#B13325",
    red300: "#DB3927",
    red400: "#F27769",
    red500: "#F7AEA6",
    red600: "#FFDBD7",
    red700: "#FFEDEB",
    green50: "#1C472F",
    green100: "#2B6B46",
    green200: "#368759",
    green300: "#3AA76D",
    green400: "#73C496",
    green500: "#AEDDC2",
    green600: "#DAF0E3",
    green700: "#F0F9F4",
    blue50: "#172B5D",
    blue100: "#23418C",
    blue200: "#2D53B1",
    blue300: "#3B6CE9",
    blue350: "#007BFF",
    blue400: "#6790EE",
    blue500: "#A6BEF3",
    blue600: "#D7E2FA",
    blue700: "#F0F3FD",
    cyan50: "#1B5B80",
    cyan100: "#3383AF",
    cyan200: "#3A9BD1",
    cyan300: "#63C7FF",
    cyan400: "#92D7FE",
    cyan500: "#B6E5FF",
    cyan600: "#D2EFFF",
    cyan700: "#EFF8FF",
    purple50: "#261650",
    purple100: "#361D77",
    purple200: "#5D39BB",
    purple300: "#7340E4",
    purple400: "#9168EC",
    purple500: "#BFA8F2",
    purple600: "#E3D7FD",
    purple700: "#F5F2FC",
    purpleAlpha50: "#210066DE",
    purpleAlpha100: "#3500ABCC",
    purpleAlpha200: "#4208C2BF",
    purpleAlpha300: "#5407FE91",
    purpleAlpha400: "#5407FE61",
    purpleAlpha500: "#5407FE36",
    purpleAlpha600: "#4F00FF14",
    purpleAlpha700: "rgba(62, 14, 169, 0.04)",
    gellyPurple: "#8d3ccf",
    development: "#A6BEF3",
    disabledDevelopment: "#404B5AB2",
    backgroundDevelopment: "rgba(162, 185, 215, 0.21)",
    inputAlpha: "rgba(0, 0, 0, 0.01)",
    splashIllustrationBackground: "#F8F8FE",
    backgroundEnvironmentSettingsCalloutDevelopment: "#EBF0F6",
    contentEnvironmentSettingsCalloutDevelopment: "rgba(64, 75, 90, 0.60)",
    backgroundEnvironmentSettingsCalloutProduction: "#F2EDFD",
    backgroundProduction: "#C5ADFA36",
    contentEnvironmentSettingsCalloutProduction: "#5634AE99"
};
const gadgetShadows = {
    selected: "0px 2px 0px 1px rgb(66, 66, 252, 0.3)",
    depth2: "0px 3px 2px -1px rgba(0, 0, 0, 0.12)",
    depth3: "0px 8px 16px -4px rgba(0, 0, 0, 0.24)",
    depth4: "0px 12px 20px -8px rgba(0, 0, 0, 0.32)",
    shadowButton: "0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonPrimary: "0px -2px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset",
    shadowButtonPrimaryInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.32) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset",
    shadowInputInset: "0px 1px 1px 0px rgba(0, 0, 0, 0.08) inset"
};
const productTypography = {
    title: {
        fontFamily: "Inconsolata",
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "30px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    navTitle: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "1px",
        textAlign: "left"
    },
    heading: {
        fontFamily: "Inconsolata",
        fontSize: "16px",
        fontWeight: 700,
        lineHeight: "22px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    subHeading: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    body: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    caption: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    contentLink: {
        textDecoration: "none"
    }
};
const getPrimitiveColors = (palette)=>({
        accent: palette.electricBlue500,
        accent50: palette.purple50,
        accent100: palette.purple100,
        accent200: palette.purple200,
        accent300: palette.purple300,
        accent400: palette.purple400,
        accent500: palette.purple500,
        accent600: palette.purple600,
        accent700: palette.purple700,
        negative50: palette.red50,
        negative100: palette.red100,
        negative200: palette.red200,
        negative300: palette.red300,
        negative400: palette.red400,
        negative500: palette.red500,
        negative600: palette.red600,
        negative700: palette.red700,
        warning50: palette.yellow50,
        warning100: palette.yellow100,
        warning200: palette.yellow200,
        warning300: palette.yellow300,
        warning400: palette.yellow400,
        warning500: palette.yellow500,
        warning600: palette.yellow600,
        warning700: palette.yellow700,
        positive50: palette.green50,
        positive100: palette.green100,
        positive200: palette.green200,
        positive300: palette.green300,
        positive400: palette.green400,
        positive500: palette.green500,
        positive600: palette.green600,
        positive700: palette.green700,
        primary50: palette.primary50,
        primary100: palette.primary100,
        primary200: palette.primary200,
        primary300: palette.primary300,
        primary400: palette.primary400,
        primary500: palette.primary500,
        primary600: palette.primary600,
        primary700: palette.primary700
    });
const space = {
    scale0: "2px",
    scale100: "4px",
    scale200: "6px",
    scale300: "8px",
    scale400: "10px",
    scale500: "12px",
    scale550: "14px",
    scale600: "16px",
    scale650: "18px",
    scale700: "20px",
    scale750: "22px",
    scale800: "24px",
    scale850: "28px",
    scale900: "32px",
    scale950: "36px",
    scale1000: "40px",
    scale1200: "48px",
    scale1400: "56px",
    scale1600: "64px",
    scale2400: "96px",
    scale3200: "128px",
    scale4800: "192px"
};
const radii = {
    radius100: "2px",
    radius200: "4px",
    radius300: "8px",
    radius400: "12px"
};


/***/ }),

/***/ 45439:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  g: () => (/* binding */ KeyNormalizedControl)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(89944);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(10608);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-hotkeys-ce@2.0.6_react@0.0.0-experimental-4ead6b530/node_modules/react-hotkeys-ce/index.es.js
var index_es = __webpack_require__(49596);
// EXTERNAL MODULE: ../@gadgetinc/errors/index.ts
var errors = __webpack_require__(54960);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/toaster.js + 2 modules
var toaster = __webpack_require__(32777);
;// ../@gadgetinc/widgets/src/utils/feedback.tsx


const messageWithoutCode = (message)=>{
    return message.substring(message.indexOf(":") + 1);
};
const tryWithUserFeedback = (action)=>{
    try {
        action();
    } catch (error) {
        if (error instanceof errors/* UserInitiatedActionSemanticError */.Hr) {
            toaster/* default */.A.negative(messageWithoutCode(error.message), {
                autoHideDuration: 3000
            });
        } else {
            throw error;
        }
    }
};

;// ../@gadgetinc/widgets/src/utils/KeyNormalizedControl.tsx





const KeyNormalizedControl = (0,es/* observer */.PA)((props)=>{
    const [, $theme] = (0,styled/* useStyletron */.c6)();
    const ignoreKeyProps = {
        ...props.ignoreKeyProps ?? {}
    };
    const hotKeyProps = {
        handlers: {},
        keyMap: {}
    };
    const baseExceptions = [
        "escape",
        "meta",
        "ctrl",
        "shift",
        "p",
        "k"
    ];
    if (props.mode == "form") {
        ignoreKeyProps.only = [
            "up",
            "down",
            "left",
            "right",
            "enter",
            "space",
            "Delete",
            "backspace"
        ];
    } else if (props.mode == "simple") {
        ignoreKeyProps.only = [
            "enter",
            "space"
        ];
    } else if (props.mode == "select") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.mode == "textarea") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.engagementBoundary) {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.keyMap["FINISHED_EDITING"] = [
            "enter"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.handlers["FINISHED_EDITING"] = (event)=>{
            event?.preventDefault();
            tryWithUserFeedback(()=>props.onFinish?.());
        };
    } else {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down",
            "enter"
        ];
    }
    const innerContent = /*#__PURE__*/ react.createElement(index_es.IgnoreKeys, ignoreKeyProps, props.children);
    return props.hasHotKeys ? /*#__PURE__*/ react.createElement(index_es.HotKeys, {
        ...hotKeyProps,
        style: {
            minHeight: "32px"
        }
    }, innerContent) : innerContent;
});


/***/ })

}]);